import { BlackListGrade } from 'src/admin-entity/enum/user/black-list-grade.enum';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';
import { BlackUser } from 'src/admin-entity/interface/user/black-user.interface';

export interface UserInitType {
    blackListSearchCondition: {
        searchToken: string;
        searchString: string;
        blacklistGrade: BlackListGrade | 'all';
        isAppUser: string;
        page: number;
        take: number;
    };
    blackList: Page<BlackUser>;
    user: any;
    nicknameChangeToken: number;
}
export const userInitState: UserInitType = {
    blackList: {
        list: [],
        page: {
            count: 0,
        },
    },
    blackListSearchCondition: {
        searchToken: 'name',
        searchString: '',
        blacklistGrade: 'all',
        isAppUser: 'all',
        page: 0,
        take: 10,
    },
    user: null,
    nicknameChangeToken: 0,
};
